<template>
  <div class="subheader">
    <div class="bet-type-dropdown" v-click-outside="closeDropdown">
      <button class="dropdown-trigger" @click="toggleDropdown">
        <span class="dropdown-label">{{ currentLabel }}</span>
        <v-icon class="dropdown-arrow" :class="{ open: dropdownOpen }">mdi-chevron-down</v-icon>
      </button>

      <div class="dropdown-menu" v-show="dropdownOpen">
        <div
            class="dropdown-item"
            :class="{ active: getBet.type == 'single' || getBet.type == 'multiple' }"
            @click="selectType('multiple')"
        >
          <span v-if="getBet.type == 'single' && getSettings.single">{{ $t('single') }}</span>
          <span v-else>{{ $t('multiple') }}</span>
        </div>
        <div
            v-if="getSettings.integral"
            class="dropdown-item"
            :class="{ active: getBet.type == 'integral' }"
            @click="selectType('integral')"
        >
          <span>{{ $t('integral') }}</span>
        </div>
        <div
            v-if="getSettings.system"
            class="dropdown-item"
            :class="{
              active: getBet.type == 'system',
              disabled: getBet.type == 'integral' || getBet.type == 'single' || getBet.odds.length == 1 || getBet.odds.length > 10 || hasBetBuilder
            }"
            @click="selectType('system')"
        >
          <span>{{ $t('system') }}</span>
        </div>
      </div>
    </div>

    <div class="delete-all pointer" @click="clearCart">
      <v-icon dense>mdi-delete</v-icon>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'BetTypeSelector',
    directives: {
      clickOutside: {
        bind(el, binding) {
          el._clickOutsideHandler = (e) => {
            if (!el.contains(e.target)) binding.value();
          };
          document.addEventListener('click', el._clickOutsideHandler);
        },
        unbind(el) {
          document.removeEventListener('click', el._clickOutsideHandler);
        },
      },
    },
    data: () => ({
      dropdownOpen: false,
    }),
    computed: {
      ...mapGetters({
        'getBet': 'cart/getBet',
        'getSettings': 'cart/getSettings',
        'hasBetBuilder': 'cart/hasBetBuilder',
      }),
      currentLabel() {
        const type = this.getBet.type;
        if (type === 'single' && this.getSettings.single) return this.$t('single');
        if (type === 'integral') return this.$t('integral');
        if (type === 'system') return this.$t('system');
        return this.$t('multiple');
      },
    },
    methods: {
      async clearCart() {
        this.$root.$emit('cart_handling', true);
        await this.resetCart();
      },
      ...mapActions({
        'refreshCart': 'cart/refreshCart',
        'setBetType': 'cart/setBetType',
        'resetCart': 'cart/resetCart',
      }),
      toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
      },
      closeDropdown() {
        this.dropdownOpen = false;
      },
      async selectType(type) {
        this.closeDropdown();
        await this.changeTypeCart(type);
      },
      async changeTypeCart(type) {
        if (this.getBet.odds.length > 10 && type === 'system') return;
        if (this.getBet.type === 'integral' && type === 'system') return;
        if (this.getBet.type !== 'simple' && this.getBet.odds.length > 1) {
          await this.setBetType({ type });
          await this.refreshCart();
        }
      },
    },
  };
</script>

<style scoped>
/* ── Subheader container ─────────────────────────────────── */
.subheader {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
}

/* ── Bet type dropdown ───────────────────────────────────── */
.bet-type-dropdown {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 4px;
}

.dropdown-trigger {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: var(--text-platform);
    font-size: var(--font-size-2xl);
    font-weight: 600;
    text-transform: capitalize;
    user-select: none;
    outline: none;
}

.dropdown-arrow {
    font-size: var(--font-size-6xl) !important;
    color: var(--text-op-50-platform) !important;
    transition: transform 0.2s ease;
}

.dropdown-arrow.open {
    transform: rotate(180deg);
}

.dropdown-menu {
    position: absolute;
    top: calc(100% + 4px);
    left: 4px;
    min-width: 130px;
    background: var(--sidebar);
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
    z-index: 100;
    overflow: hidden;
}

.dropdown-item {
    padding: 10px 14px;
    font-size: var(--font-size-2xl);
    font-weight: 400;
    text-transform: capitalize;
    color: #8a94a6;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    user-select: none;
    white-space: nowrap;
}

.dropdown-item:hover:not(.disabled) {
    background: rgba(255, 255, 255, 0.05);
    color: var(--text-platform);
}

.dropdown-item.active {
    color: var(--color-primary, #007aff);
    font-weight: 600;
}

.dropdown-item.disabled {
    color: #3e4654;
    cursor: not-allowed;
}

/* ── Delete all button ───────────────────────────────────── */
.delete-all {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px ;
    font-size: var(--font-size-xl);
    color: #ef4444;
    cursor: pointer;
    transition: color 0.15s;
    white-space: nowrap;
    user-select: none;
}

.delete-all:hover {
    color: #ef4444;
}

.delete-all .v-icon {
    font-size: var(--font-size-7xl) !important;
    color: inherit !important;
}

.delete-all span {
    padding-right: 0;
}
</style>